<template>
  <div class="menu">
    <div>
      <h2>MIELOUPE</h2>
      <ul>
        <li >
          <router-link to="/" class="menu-link" active-class="selected">
            <font-awesome-icon :icon="['fas', 'fa-home']" /> ダッシュボード
          </router-link>
        </li>
        <li>
          <a href="#" @click.prevent="toggleSubmenu(2)">
            <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 鳥獣被害対策管理
          </a>
          <ul class="submenu" v-show="isSubmenuVisible[2]">
            <li>
              <router-link to="/damageMap" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-map-marker-alt']" /> 鳥獣被害表示（地図）
              </router-link>
            </li>
            <li>
              <router-link to="/damageList" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-list']" /> 鳥獣被害一覧
              </router-link>
            </li>
            <li>
              <router-link to="/counterPlanList" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-list']" /> 鳥獣対策一覧
              </router-link>
            </li>
          </ul>
        </li>
        <br>
        <hr>
        <li v-if="section && (section.startsWith('00')) && section.endsWith('0')">
          <a href="#" @click.prevent="toggleSubmenu(1)">
            <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 行政機関管理
          </a>
          <ul class="submenu" v-show="isSubmenuVisible[1]">
            <li>
              <router-link to="/agencyRegister" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 行政機関マスター登録
              </router-link>
            </li>
            <li>
              <router-link to="/agencyEdit" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 行政機関マスター編集
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <a href="#" @click.prevent="toggleSubmenu(3)">
            <font-awesome-icon :icon="['fas', 'fa-list']" /> 利用者情報管理
          </a>
          <ul class="submenu" v-show="isSubmenuVisible[3]">
            <li>
              <router-link to="/user" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-user']" /> 利用者情報表示
              </router-link>
            </li>
            <li v-if="section.endsWith('0')">
              <router-link to="/userRegister" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 利用者情報登録
              </router-link>
            </li>
            <li>
              <router-link to="/userEdit" class="menu-link" active-class="selected">
                <font-awesome-icon :icon="['fas', 'fa-tasks']" /> 利用者情報編集
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <br>
    <!-- ログアウトボタン -->
    <button class="logout-button" @click="logout">
      <i class="fas fa-sign-out-alt"></i> ログアウト
    </button>
  </div>
</template>

<script>
import "@/assets/styles/TheMenuBar.css";

export default {
  data() {
    return {
      isSubmenuVisible: { 1: false, 2: false, 3: false },
      section: localStorage.getItem("section") || "", // 利用者区分を取得
    };
  },
  methods: {
    
    toggleSubmenu(index) {
      // 指定されたサブメニューの表示・非表示をトグルし、他は閉じる
      this.isSubmenuVisible = {
        ...this.isSubmenuVisible,
        [index]: !this.isSubmenuVisible[index],
      };
    },
    logout() {
      try {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("section");
        this.$router.push("/login");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>


<style scoped>
</style>
